class AditivoEnviarRequest {
    get idPropostaRepactuacao() {
        return this._idPropostaRepactuacao;
    }

    set idPropostaRepactuacao(value) {
        this._idPropostaRepactuacao = value;
    }

    get tipo() {
        return this._tipo;
    }

    set tipo(value) {
        this._tipo = value;
    }

    get base64() {
        return this._base64;
    }

    set base64(value) {
        this._base64 = value;
    }

    constructor(idPropostaRepactuacao, tipo, base64) {
        this._idPropostaRepactuacao = idPropostaRepactuacao;
        this._tipo = tipo;
        this._base64 = base64;
    }

}

export default AditivoEnviarRequest
